<!-- eslint-disable vue/multi-word-component-names -->
<!-- So Much A Part of You View -->
<template>
  <div class="break"></div>
  <page-layout left right header="So Much a Part of You" :hook="hook">
    <template #left>
      <book-menu />
    </template>
    <template #right>
      <book-content :book="bookCover" :paragraphs="introParagraphs" />
      <divider />
      <p class="other-paragraph">
        Possessing that rare ability to write the sweep of emotion with
        tenderness, Polly Dugan invites readers to witness the moments that
        define her characters -- the moments that come back full circle to
        comfort or haunt them, or both. <em>So Much a Part of You</em> will
        break your heart and still have you asking for more.
      </p>
      <divider />
      <h4>Purchase the Book</h4>
      <div class="buttonBox">
        <Button label="Amazon" :link="buttonLinks.amazon" />
        <Button label="Powell's Books" :link="buttonLinks.powells" />
        <Button label="Barnes & Noble" :link="buttonLinks.barnesAndNoble" />
      </div>
      <divider />
      <book-praise header="Praise" :praises="bookPraise" />
    </template>
  </page-layout>
</template>

<script>
// import components
import PageLayout from "@/components/global-styles/layout/PageLayout.vue";
import BookMenu from "@/components/global-styles/default/BookMenu.vue";
import BookContent from "@/components/global-styles/layout/BookContent.vue";
import Divider from "@/components/global-styles/default/Divider.vue";
import Button from "@/components/global-styles/components/Button.vue";
import BookPraise from "@/components/global-styles/layout/BookPraise.vue";

// import images
import smapoyCover from "@/assets/images/book-covers/SMAPOYCover.jpg";

export default {
  name: "SMAPOYView",
  components: {
    PageLayout,
    BookMenu,
    BookContent,
    Divider,
    Button,
    BookPraise,
  },
  data() {
    return {
      bookCover: smapoyCover,
      introParagraphs: [
        `Taking place within the Irish Catholic culture, imbued with all its discrete expectations and fears, the stories span from the Depression to the present and force Anna Riley and Anne Cavanaugh and their families up against the emotional and moral burdens of alcoholism, abortion, infidelity, and the losses of friends, parents and children. The women's lives unexpectedly converge because of Peter Herring, the lover they have in common.`,
        `Through exploring Anne's and Anna's ties to Peter and unfolding the narratives of the people who weave meaningfully in and out of their lives, Polly Dugan reveals the power of family secrets, the ripple effects of her characters' emotional choices, and how poignantly their intertwined relationships shape who they are and how they love.`,
      ],
      buttonLinks: {
        amazon:
          "https://www.amazon.com/Much-Part-You-Polly-Dugan/dp/0316320293/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=&sr=",
        powells:
          "https://www.powells.com/book/so-much-a-part-of-you-9780316320290",
        barnesAndNoble:
          "https://www.barnesandnoble.com/w/so-much-a-part-of-you-polly-dugan/1117054801?ean=9780316320290",
      },
      hook: `Like a hidden family photo album, these ten linked stories capture
        pivotal moments in time that leave lasting, intimate impressions.`,
      bookPraise: [
        {
          quote:
            "Polly Dugan strikes the heart in <em>So Much a Part of You</em>.",
          attribution: "—Elissa Schappell, <em>Vanity Fair</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "Dugan’s writing flows well and with thoughtfulness as she explores love, loss, and friendship through the three main characters and their families. Their decisions and foibles make for some emotional reading.",
          attribution: "—<em>Publishers Weekly</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "A debut collection that could practically pass for a novel…. Dugan’s stories move through the conventional details of domesticity to panic attacks and ‘uncharted insanity,’ showing the fragility beneath even the most stable lives.",
          attribution: "—<em>Kirkus Reviews</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "A quiet triumph…. <em>So Much a Part of You</em> marries the scope of a novel with the graceful economy of a good short story. The linked stories in the collection are individually modest, almost unobtrusive. against one another, though, they reveal surprising connections—reflecting perspective and insight back onto themselves…. Part of the pleasure of this book is that it brings the reader into glancing proximity to so many people, and so many stories. It’s about as close as fiction comes to capturing the way people really do move in and out of each other’s lives.",
          attribution: "—Alison Hallett, <em>Portland Mercury</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "This is what short story should be: exact and faithful invocations, full of nerve and stranded emotion, which leave eddying waves of thought and strangeness that linger long after the covers are closed shut. The stories are simultaneously eerie and poignant. They achieve a cool distance and the captured moment, the effect of which is to show us how lonely and alien we can be to ourselves and together. The pathway to the heart is through the mind.",
          attribution: "—Robert Olmstead, author of <em>The Coldest Night</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "The ten stories in this collection are beautiful and connected in unexpected ways—but underneath the beauty, the stories hum with electricity that is as unpredictable as a downed power line, as dangerous as the third rail. I read with my breath held, and my heart in my throat. These are the best kind of stories—dark and tender and sharp.",
          attribution:
            "—Jodi Angel, author of <em>You Only Get Letters from Jail</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "Polly Dugan’s stories read like whispered secrets. With their quiet drama, their nuanced internal conflicts, their characters full of longing, they immerse us in the messy mysteries of ordinary lives. But their vision is clear-headed and generous: they show us that even our briefest connections, our smallest actions, our most private thoughts, can have great weight and consequence.",
          attribution: "—Scott Nadelson, author of <em>Aftermath</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "Polly Dugan makes the greatest deal that literature can offer—she will be honest, completely bare, and deliver a reader wholly into the secret world of her character’s empathy. What a powerful and glorious thing it was to become these characters, to have my worldview touched by their lives. It’s a rare skill to write pain with such love, such care, such warmth, and like Alice Munro and Elizabeth Strout, Polly Dugan has achieved a small miracle in breaking my heart and still having me ask for more. <em>So Much a Part of You</em> announces a potent and fresh new voice to the landscape of short fiction.",
          attribution: "—Alan Heathcock, author of <em>Volt: Stories</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "There’s a rawness to Polly Dugan’s stories that lures you in and won’t let you go. The settings may be everyday, but <em>So Much a Part of You</em> lingers in the imagination.",
          attribution: "—Lucinda Rosenfeld, author of <em>The Pretty One</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "By portraying various individuals in their twenties and thirties as they move through formative stages in their lives, the ten linked stories in Dugan’s debut collection convincingly capture the human condition…. With decisive economy and the dramatic immediacy lent by her use of the present tense, Dugan’s powerful stories present a fast-paced, cohesive, and satisfying read.",
          attribution: "—Joyce Townsend, <em>Library Journal</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "A promising debut…. Strong characterization and acute rendering of settings provide glimpses into the successes and sorrows of the middle-class Irish Catholics.",
          attribution: "—Ellen Loughran, <em>Booklist</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote: "Utterly real and insightful.",
          attribution: "—<em>BookPage</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
      ],
    };
  },
};
</script>
